(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/column-video/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_layouts/column-video/assets/javascripts/prescript.js');
svs.banner_layouts = svs.banner_layouts || {};
svs.banner_layouts.column_video = svs.banner_layouts.column_video || {};


 })(window);